// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import useBurnRequests3Step from './useBurnRequests';
import { useBurnRequests2Step } from './useBurnRequests2Step';
import useExecutedBurns3Step from './useExecutedBurns';
import { useExecutedBurns2Step } from './useExecutedBurns2Step';
import useFailedBurns3Step from './useFailedBurns';
import useRejectedBurns3Step from './useRejectedBurns';
import { useRejectedBurns2Step } from './useRejectedBurns2Step';

export const useGetBurnQueries = () => {
  // 2step
  const burnRequests2Step = useBurnRequests2Step();
  const executedBurns2Step = useExecutedBurns2Step();
  const rejectedBurns2Step = useRejectedBurns2Step();

  // 3 step
  const burnRequests3Step = useBurnRequests3Step();
  const rejectedBurns3Step = useRejectedBurns3Step();
  const failedBurns3Step = useFailedBurns3Step();
  const executedBurns3Step = useExecutedBurns3Step();

  return {
    burnRequests2Step,
    executedBurns2Step,
    rejectedBurns2Step,
    burnRequests3Step,
    rejectedBurns3Step,
    failedBurns3Step,
    executedBurns3Step,
  };
};
